<script>
  import SocialMedia from "./SocialMedia.svelte";
  import SectionHeading from "../shared/SectionHeading.svelte";
  import theme from "../stores/theme";
  import app from "../stores/app";

  $: bg = $theme.mode == "dark" ? "bg-brand-black" : "bg-white";
  $: text = $theme.mode == "dark" ? "text-brand-yellow" : "text-gray-800";

  let sending = false;

  let message = {
    name: "",
    email: "",
    tel: "",
    object: "",
    content: "",
  };

  let handleSubmit = () => {
    sending = true;

    var templateParams = message;

    emailjs
      .send("service_portfolio", "template_portfolio", templateParams)
      .then(
        (response) => {
          sending = false;
          console.log("SUCCESS!", response.status, response.text);
          alert(`🙂 Thank you for the message, I'll get back to you!`);
          message = { name: "", email: "", tel: "", object: "", content: "" };
        },
        (error) => {
          console.log("FAILED...", error);
          alert(
            `🙂 The email service is down, Whatsapp will open to get in touch with me!`,
          );
          sending = false;
          if ($app.lang === "en") {
            window.open(
              `https://wa.me/27682101486 ?text=${encodeURI(
                `Hey Glory, this is ${message.name} <${message.email}>, \n\n~${message.object} \n\n${message.content} \n\nMy Cell number is: ${message.tel}`,
              )}`,
            );
          } else {
            window.open(
              `https://wa.me/27682101486 ?text=${encodeURI(
                `Bonjour Glory, c'est ${message.name} <${message.email}>, \n\n~${message.object} \n\n${message.content} \n\nMon numero est: ${message.tel}`,
              )}`,
            );
          }
        },
      );
  };
</script>

<div class="relative" id="contact">
  <div class="max-w-7xl mx-auto px-4 py-4 overflow-x-hidden" id="my-work">
    {#if $app.lang === "en"}
      <SectionHeading text1="REACH" text2="ME" />
    {:else}
      <SectionHeading text1="ME" text2="CONTACTER" />
    {/if}

    <div class="flex flex-col md:flex-row">
      <!-- Left Pane -->
      <div
        class={`pt-4 pb-3 my-patterns flex flex-col justify-center items-center contact-card overflow-hidden ${bg}  shadow-sm relative w-full max-w-sm sm:max-w-none sm:w-112 md:w-160 mx-auto`}
      >
        <div
          class="w-full overflow-hidden relative rounded-full border-2 border-brand-yellow"
          style="height: 10rem; width: 10rem; background-image: url(./images/profile.png); background-size: cover; background-position: center;"
        />

        <div class="mt-2 text-2xl h-font {text}">Glory K. Katende</div>

        <div class="mt-2 flex items-center mb-2">
          <span
            class="material-symbols-outlined mr-2"
            style="font-size: 1.75rem;"
          >
            perm_phone_msg
          </span>
          <a href="tel:+27682101486 ">+27 68 210 1486 </a>
        </div>

        <div class="flex items-center">
          <span
            class="material-symbols-outlined mr-2"
            style="font-size: 1.75rem;"
          >
            email
          </span>
          <a href="mailto:hello@glorykatende.com" target="_blank">
            hello@glorykatende.com
          </a>
        </div>

        <div class="mt-4">
          <SocialMedia />
        </div>

        <!-- <img
          src="./images/card-tablets-yellow.svg"
          class="absolute left-0 opacity-50"
          style="top: 25%; transform: translate(0, 0);"
          alt="tablets"
        /> -->
      </div>

      <!-- Right Pane -->
      <form
        data-aos="fade-left"
        data-aos-delay="150"
        on:submit|preventDefault={handleSubmit}
        class="aos-item w-full mt-5 md:mt-0 md:ml-5"
      >
        <h1 class="mb-4 opacity-75 hidden md:flex items-center">
          <span
            class="material-symbols-outlined text-brand-green text-6xl mr-2"
          >
            info
          </span>
          {#if $app.lang === "en"}
            <span> I hereby solemnly declare to never spam you! :) </span>
          {:else}
            <span>
              Je déclare solennellement de ne jamais vous envoyer de spam! :)
            </span>
          {/if}
        </h1>

        <div class="">
          <input
            bind:value={message.name}
            type="text"
            class={`text-field w-full mb-4 ${bg}`}
            required
            placeholder={$app.lang === "en" ? "Your Name" : "Votre Nom"}
          />
          <input
            bind:value={message.tel}
            type="tel"
            class={`text-field w-full mb-4 ${bg}`}
            required
            placeholder="Telephone"
          />
        </div>

        <div class="lg:flex">
          <input
            bind:value={message.email}
            type="email"
            class={`text-field w-full lg:w-1/2 lg:mr-4 mb-4 ${bg}`}
            required
            placeholder="Email"
          />
          <input
            bind:value={message.object}
            type="text"
            class={`text-field w-full lg:w-1/2 mb-4 ${bg}`}
            required
            placeholder="Object"
          />
        </div>

        <div class="">
          <textarea
            bind:value={message.content}
            class={`text-field w-full mb-4 ${bg}`}
            required
            rows="4"
            placeholder="Message..."
          />
        </div>

        <div class="w-full flex justify-end">
          <button
            disabled={sending}
            class="text-field bg-brand-green text-gray-300 items-center justify-center w-full"
            style="display: flex !important; padding: 0.4rem 1rem;"
          >
            {#if sending}
              Sending...
              <span
                class="material-symbols-outlined ml-2 text-4xl"
                style="font-size: 2rem;"
              >
                pending
              </span>
            {:else}
              {#if $app.lang === "en"}
                <span> Send your message </span>
              {:else}<span> Envoyer votre message </span>{/if}
              <span
                class="material-symbols-outlined ml-2 text-4xl"
                style="font-size: 2rem;"
              >
                send
              </span>
            {/if}
          </button>
        </div>

        <h1 class="mt-8 flex items-center md:hidden opacity-50">
          <span
            style="font-size: 2.25rem"
            class="material-symbols-outlined mr-2 text-brand-green"
          >
            info
          </span>
          {#if $app.lang === "en"}
            <span> I hereby solemnly declare to never spam you! :) </span>
          {:else}
            <span>
              Je déclare solennellement de ne jamais vous envoyer de spam! :)
            </span>
          {/if}
        </h1>
      </form>
    </div>
  </div>
  <!-- Absolute elements -->
</div>

<div class="py-8"></div>

<style>
  .contact-card {
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 0px;
  }

  @media (min-width: 768px) {
    .contact-card {
      border-radius: 0;
      /* border-top-right-radius: 25px; */
      border-bottom-left-radius: 25px;
    }
  }

  .my-patterns {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 150 150' width='100' height='100'%3E%3Cpath fill='%23FFFFFF' fill-opacity='0.015' d='M44.1 224a5 5 0 1 1 0 2H0v-2h44.1zm160 48a5 5 0 1 1 0 2H82v-2h122.1zm57.8-46a5 5 0 1 1 0-2H304v2h-42.1zm0 16a5 5 0 1 1 0-2H304v2h-42.1zm6.2-114a5 5 0 1 1 0 2h-86.2a5 5 0 1 1 0-2h86.2zm-256-48a5 5 0 1 1 0 2H0v-2h12.1zm185.8 34a5 5 0 1 1 0-2h86.2a5 5 0 1 1 0 2h-86.2zM258 12.1a5 5 0 1 1-2 0V0h2v12.1zm-64 208a5 5 0 1 1-2 0v-54.2a5 5 0 1 1 2 0v54.2zm48-198.2V80h62v2h-64V21.9a5 5 0 1 1 2 0zm16 16V64h46v2h-48V37.9a5 5 0 1 1 2 0zm-128 96V208h16v12.1a5 5 0 1 1-2 0V210h-16v-76.1a5 5 0 1 1 2 0zm-5.9-21.9a5 5 0 1 1 0 2H114v48H85.9a5 5 0 1 1 0-2H112v-48h12.1zm-6.2 130a5 5 0 1 1 0-2H176v-74.1a5 5 0 1 1 2 0V242h-60.1zm-16-64a5 5 0 1 1 0-2H114v48h10.1a5 5 0 1 1 0 2H112v-48h-10.1zM66 284.1a5 5 0 1 1-2 0V274H50v30h-2v-32h18v12.1zM236.1 176a5 5 0 1 1 0 2H226v94h48v32h-2v-30h-48v-98h12.1zm25.8-30a5 5 0 1 1 0-2H274v44.1a5 5 0 1 1-2 0V146h-10.1zm-64 96a5 5 0 1 1 0-2H208v-80h16v-14h-42.1a5 5 0 1 1 0-2H226v18h-16v80h-12.1zm86.2-210a5 5 0 1 1 0 2H272V0h2v32h10.1zM98 101.9V146H53.9a5 5 0 1 1 0-2H96v-42.1a5 5 0 1 1 2 0zM53.9 34a5 5 0 1 1 0-2H80V0h2v34H53.9zm60.1 3.9V66H82v64H69.9a5 5 0 1 1 0-2H80V64h32V37.9a5 5 0 1 1 2 0zM101.9 82a5 5 0 1 1 0-2H128V37.9a5 5 0 1 1 2 0V82h-28.1zm16-64a5 5 0 1 1 0-2H146v44.1a5 5 0 1 1-2 0V18h-26.1zm102.2 270a5 5 0 1 1 0 2H98v14h-2v-16h124.1zM242 149.9V160h16v34h-16v62h48v48h-2v-46h-48v-66h16v-30h-16v-12.1a5 5 0 1 1 2 0zM53.9 18a5 5 0 1 1 0-2H64V2H48V0h18v18H53.9zm112 32a5 5 0 1 1 0-2H192V0h50v2h-48v48h-28.1zm-48-48a5 5 0 0 1-9.8-2h2.07a3 3 0 1 0 5.66 0H178v34h-18V21.9a5 5 0 1 1 2 0V32h14V2h-58.1zm0 96a5 5 0 1 1 0-2H137l32-32h39V21.9a5 5 0 1 1 2 0V66h-40.17l-32 32H117.9zm28.1 90.1a5 5 0 1 1-2 0v-76.51L175.59 80H224V21.9a5 5 0 1 1 2 0V82h-49.59L146 112.41v75.69zm16 32a5 5 0 1 1-2 0v-99.51L184.59 96H300.1a5 5 0 0 1 3.9-3.9v2.07a3 3 0 0 0 0 5.66v2.07a5 5 0 0 1-3.9-3.9H185.41L162 121.41v98.69zm-144-64a5 5 0 1 1-2 0v-3.51l48-48V48h32V0h2v50H66v55.41l-48 48v2.69zM50 53.9v43.51l-48 48V208h26.1a5 5 0 1 1 0 2H0v-65.41l48-48V53.9a5 5 0 1 1 2 0zm-16 16V89.41l-34 34v-2.82l32-32V69.9a5 5 0 1 1 2 0zM12.1 32a5 5 0 1 1 0 2H9.41L0 43.41V40.6L8.59 32h3.51zm265.8 18a5 5 0 1 1 0-2h18.69l7.41-7.41v2.82L297.41 50H277.9zm-16 160a5 5 0 1 1 0-2H288v-71.41l16-16v2.82l-14 14V210h-28.1zm-208 32a5 5 0 1 1 0-2H64v-22.59L40.59 194H21.9a5 5 0 1 1 0-2H41.41L66 216.59V242H53.9zm150.2 14a5 5 0 1 1 0 2H96v-56.6L56.6 162H37.9a5 5 0 1 1 0-2h19.5L98 200.6V256h106.1zm-150.2 2a5 5 0 1 1 0-2H80v-46.59L48.59 178H21.9a5 5 0 1 1 0-2H49.41L82 208.59V258H53.9zM34 39.8v1.61L9.41 66H0v-2h8.59L32 40.59V0h2v39.8zM2 300.1a5 5 0 0 1 3.9 3.9H3.83A3 3 0 0 0 0 302.17V256h18v48h-2v-46H2v42.1zM34 241v63h-2v-62H0v-2h34v1zM17 18H0v-2h16V0h2v18h-1zm273-2h14v2h-16V0h2v16zm-32 273v15h-2v-14h-14v14h-2v-16h18v1zM0 92.1A5.02 5.02 0 0 1 6 97a5 5 0 0 1-6 4.9v-2.07a3 3 0 1 0 0-5.66V92.1zM80 272h2v32h-2v-32zm37.9 32h-2.07a3 3 0 0 0-5.66 0h-2.07a5 5 0 0 1 9.8 0zM5.9 0A5.02 5.02 0 0 1 0 5.9V3.83A3 3 0 0 0 3.83 0H5.9zm294.2 0h2.07A3 3 0 0 0 304 3.83V5.9a5 5 0 0 1-3.9-5.9zm3.9 300.1v2.07a3 3 0 0 0-1.83 1.83h-2.07a5 5 0 0 1 3.9-3.9zM97 100a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-48 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 96a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-144a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM49 36a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM33 68a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 240a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm80-176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm112 176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 180a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 84a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'%3E%3C/path%3E%3C/svg%3E");
  }
</style>
